import { sendPostRequest } from "services/apiService";

export const getRequestURL = (eventCode?: string | null) =>
  `/daily/${eventCode}`;

const request = async (eventCode?: string | null) => {
  const resp = await sendPostRequest<
    Record<string, never>,
    APIResponse<{ status: boolean; eventId: string }>
  >(getRequestURL(eventCode), {});

  if (!resp.status) {
    throw new Error(resp?.message ?? resp?.error);
  }

  return resp;
};

export default request;
